import React from 'react';

const HeroImagePlaceholder = () => {
  return (
    <svg viewBox="0 0 182 112" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path fill="#4C4C4C" d="M0 0h182v112H0z" />
        <path fill="#000" fillOpacity=".1" d="M0 0h182v112H0z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.061 90.756h19.225v21.124H31.06V90.756Z"
          fill="#63656A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m50.286 70.82 4.475-6.15 4.028 6.15 4.475-6.15 4.027 6.15 4.476-6.15 4.027 6.15V45.965h17.9v30.568h57.73v35.348H50.284l.002-41.06Z"
          fill="#63656A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.01 84.18H82.048v27.7H108.796V94.224H98.01V84.18Z"
          fill="#595959"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M98.43 98.49h2.341v2.506h-2.34V98.49Zm-4.68 0h2.34v2.506h-2.34V98.49Zm11.702 0h-2.341v2.506h2.341V98.49ZM53.63 74.883h2.235v2.506h-2.236v-2.506Zm8.494 0h2.235v2.506h-2.235v-2.506Zm10.73 0H70.62v2.506h2.235v-2.506ZM87.064 50.87c-1.254 0-1.672 1.253-1.672 1.253v6.266h3.343v-6.266s-.418-1.253-1.671-1.253Zm-5.016 0c-1.253 0-1.671 1.253-1.671 1.253v6.266h3.343v-6.266s-.418-1.253-1.672-1.253ZM81.948 33.052c1.126-.924 2.148-1.764 2.148-2.961 0 1.202 1.218 2.054 2.553 2.99 1.624 1.136 3.424 2.396 3.424 4.555 0 1.42-.72 2.22-1.64 2.663h5.317v3.994H75.362V40.3h5.268c-.896-.446-1.59-1.248-1.59-2.663 0-2.195 1.53-3.453 2.908-4.584ZM38.194 84.073h19.614l-7.132 7.519H31.06l7.133-7.52Z"
          fill="#8AA4A8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m57.39 84.073 7.105 7.172v20.635h-14.21V91.245l7.106-7.172Z"
          fill="#595959"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M134.57 98.275h11.839v-.934h-12.716l.877.934Zm-3.508-3.735h15.347v-.934h-16.224l.877.934Zm-3.508-3.735h18.855v-.934h-19.732l.877.934Zm-3.508-3.735h22.363v-.933h-23.24l.877.933Zm-3.507-3.735h25.87v-.933h-26.747l.877.933Z"
          fill="#8AA4A8"
        />
        <path
          d="M151.424 74.887h-19.899c0-5.495 4.455-9.95 9.95-9.95 5.495 0 9.949 4.455 9.949 9.95Z"
          fill="#63656A"
        />
        <path d="M138.805 65.52h5.824a2.912 2.912 0 1 0-5.824 0Z" fill="#8AA4A8" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h182v112H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HeroImagePlaceholder;
